var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkflowSteps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m88.35,48.43h-25.51c-1.22-5.44-6.07-9.51-11.87-9.51s-10.75,4.16-11.91,9.67H11.65c-.91,0-1.57-.15-1.96-.29v-30.47c.39-.14,1.05-.29,1.96-.29h27.07l10.53,10.53c.57.57,1.32.86,2.08.86s1.5-.29,2.08-.86l11.52-11.52c1.15-1.15,1.15-3,0-4.15L53.4.86c-1.15-1.15-3-1.15-4.15,0l-10.8,10.8H11.65c-4.61,0-7.83,2.16-7.83,5.24v32.31c0,3.09,3.22,5.24,7.83,5.24h27.64c1.47,5.07,6.14,8.79,11.68,8.79s10.31-3.8,11.72-8.95h25.65c.91,0,1.57.15,1.96.29v30.47c-.39.14-1.05.29-1.96.29h-25.43v-4.59c0-1.62-1.31-2.94-2.94-2.94h-16.3c-1.62,0-2.94,1.31-2.94,2.94v16.3c0,1.62,1.31,2.94,2.94,2.94h16.3c1.62,0,2.94-1.31,2.94-2.94v-5.84h25.43c4.61,0,7.83-2.16,7.83-5.24v-32.31c0-3.09-3.22-5.24-7.83-5.24Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkflowSteps);
export default __webpack_public_path__ + "static/media/workflowSteps.ac55057b7811e71f9af5de13c3623817.svg";
export { ForwardRef as ReactComponent };